module.exports = __webpack_public_path__ + "media/assets/icons/funnel/star-inactive-593ab3b26cad0aa15198393e7f0fceef.svg";